import React, { useRef, useEffect } from 'react';
import Swiper from 'swiper';
import styles from './About.module.sass';
import { aboutContent } from './About.content';
import { Arrow } from './assets/Arrow';
import 'swiper/dist/css/swiper.min.css';
import logo from './assets/logo.svg';

import cloud from './assets/cloud-1.webp';
import cloud2 from './assets/cloud-2.webp';

export function About() {
  const slides = aboutContent.slides;

  const containerRef = useRef(null);
  const swiperRef = useRef(null);
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;

    swiperRef.current = new Swiper(containerRef.current, {
      loop: true,
      slidesPerView: 6.5,
      spaceBetween: 10,
      speed: 700,
      navigation: {
        prevEl: prevRef.current,
        nextEl: nextRef.current,
      },
      breakpoints: {
        200: { slidesPerView: 1.2 },
        360: { slidesPerView: 1.2 },
        560: { slidesPerView: 1.2 },
        600: { slidesPerView: 2.1 },
        900: { slidesPerView: 3 },
        1440: { slidesPerView: 6.5 },
      },
    });

    return () => {
      if (swiperRef.current) {
        swiperRef.current.destroy(true, true);
        swiperRef.current = null;
      }
    };
  }, []);

  return (
    <section className={styles.about}>
      <div className={styles.about__content}>
        <img src={logo} alt="" className={styles.about__logo} />
        <div
          className={styles.about__title}
          dangerouslySetInnerHTML={{ __html: aboutContent.title }}
        />
        <div
          className={styles.about__text}
          dangerouslySetInnerHTML={{ __html: aboutContent.textTop }}
        />

        <div className={styles.about__sliderWrapper}>
          <div className={styles.about__nav}>
            <div ref={prevRef} className={styles.about__prev}>
              <Arrow />
            </div>
            <div ref={nextRef} className={styles.about__next}>
              <Arrow />
            </div>
          </div>

          <div className={`swiper-container ${styles.about__slider}`} ref={containerRef}>
            <div className="swiper-wrapper">
              {slides.map((slide) => (
                <div key={slide.id} className={`swiper-slide ${styles.slide}`}>
                  <div className={styles.slide__inner}>
                    <img src={slide.image} alt="Слайд" className={styles.slide__image} />
                    <div className={styles.slide__caption}>{slide.caption}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div
          className={styles.about__text}
          dangerouslySetInnerHTML={{ __html: aboutContent.textBottom }}
        />
      </div>
      <img src={cloud} alt="Облако" className={styles['about__cloud-1']} />
      <img src={cloud2} alt="Облако" className={styles['about__cloud-2']} />
    </section>
  );
}
